import { atom } from 'jotai';

export const deviceIDAtom = atom<string | null>(null);
